export const PublicAccessType = {
  NONE: 'NONE',
  BOOK: 'BOOK',
  VIEW: 'VIEW',
  PUBLIC_ONLY: 'PUBLIC_ONLY',
};

export const publicAccessTypes = [
  PublicAccessType.NONE,
  PublicAccessType.BOOK,
  PublicAccessType.VIEW,
  PublicAccessType.PUBLIC_ONLY,
];
